/**
 * Created by rlopez on 09/19/16.
 */

// ReportDetailsView.js

import $ from 'jquery';
import Base64Encoder from 'util/Base64Encoder.js';
import {View} from 'backbone';
import {Model} from 'backbone';
import restService from 'RestService';
import eventBus  from 'EventBus.js';
import util                 from 'util/Util.js';
import constants            from 'Constants.js';
import AlertDialogView      from 'common-views/AlertDialogView.js';
import contentTemplate      from 'dashboard/reports/report-details-view.ejs';
import contentTemplatePreview       from 'dashboard/reports/report-details-preview.ejs';
import formLoadService      from 'FormLoadService.js';
import notificationService  from 'NotificationService.js';
import ReportDeleteModal    from 'dashboard/reports/modal/ReportDeleteModal.js';
import SelectItemModalView  from 'common-views/SelectItemModalView.js'
import LinkModal            from  'dashboard/LinkModal.js';;
import ConfirmationModal    from 'dashboard/forms/modal/ConfirmationModal';
import PlayFormModal        from 'common-views/PlayFormModal.js';
import listService          from 'ListService.js';
import undoService          from 'UndoService.js'
import textConstants        from 'TextConstants';
import MigrateReportModal   from 'dashboard/reports/modal/MigrateReportModal.js';
import SimpleConfirmModalView from "common-views/SimpleConfirmModalView.js";
import SelectFileModal      from 'common-views/SelectFileModal.js';
import FormDetailsView      from 'dashboard/forms/FormDetailsView';
import PermissionsDetailView from 'dashboard/forms/PermissionsDetailView';
import configService        from 'ConfigService';
import restServiceAux       from "RestServiceAux";
import restMessages         from 'RestMessages';
import RestService from "../../../service/RestService";
import userService from 'UserService';
import Spinner from 'spin/spin';
import RecoverDesignModal from '../forms/modal/RecoverDesignModal';

class ReportDetailsView extends View {

    initialize(opts) {

        this.options = opts || {};
        this.template = contentTemplate;

        if (opts.model.get('groupType') === 'viewReports') {
            this.template = contentTemplatePreview;
        }

        this.permsSelector = `select[name='permissions']`;
        this.model.set('selectedViewer', '', {silent:true});
        configService.promise.then(config => {
            this.apiHostUrl = config.apiHostUrl;
            this.hostUrl = config.hostUrl;
        });

        this.events = {
            'change input[type="text"]': 'changeTextInputField',
            'keyup input[name="currentReportName"]': 'changeTextInputField',
            'change input[name="isActive"]': 'changeCheckboxes',
            'change input[name="version"]': 'changeVersion',
            'change #draftVersion, #deployedVersion' : 'selectVersion',
            'click #designReport': 'design',
            'click #linkReport': 'linkReport',
            'click #viewReport': 'viewReport',
            'click #publishReport': 'confirmRecoverDesign',
            'click #shareReport': 'shareReport',
            'click #deleteReport': 'deleteReport',
            'click #addPermissionReport': 'addPermission',
            'click #removePermissionReport': 'removePermission',
            'click #cancelChangesReport': 'cancelChanges',
            'click a.item-link' : 'handleSelectedItem',
            'click #migrateReport': 'migrateReport', 
            'click #goToReports': 'goToReports',
            'click #goToEditReport': 'goToReports'
        };

        if (this.model.get('hasChanges') === undefined) {
            this.model.set('hasChanges', false);
        }

        if (!this.model.get('reportName')) {
            this.model.set('reportName', '');
        }

        if (this.model.get('isActive') === undefined) {
            this.model.set('isActive', true, {silent: true});
        }

        this.model.set('currentViewerPerms', {}, {silent: true});
        this.model.set('isReport', true, {silent: true});
        
        this.model.set('isMobileDevice', util.isMobileDevice(), constants.MODEL_SILENT);
        this.model.set('mobileMessage', constants.MESSAGE_DASHBOARD_ONMOBILE, constants.MODEL_SILENT);

        if(!this.model.get("simpleView")){
            const simpleView = this.model.get("GroupId").indexOf("viewReports") > -1;
            this.model.set("simpleView", simpleView);
        }
     
        this.listenTo(this.model, 'change', this.render);
        this.listenTo(eventBus, 'applyNameReportChanges', this.applyReportNameOnTree);        

        if ( !util.isTrue(this.model.get('IsPrivate')) ) {
            this.model.set('isShared', true, {silent: true});
        } else {
            this.model.set('isShared', false, {silent: true});
        }

        listService.setDocTypeReport();

        return this;
    }

    goToReports(e) {

        e.preventDefault();
        e.stopPropagation();

        eventBus.trigger('loadReportsView');
    }

    applyReportNameOnTree(id, groupType, text) {
        let formElement = $(`a[data-itemid="${groupType}_${id}"]`);
        if (formElement) {
            formElement.text(text).attr('title', text);
        }        
    }

    applyChanges() {
        PermissionsDetailView.validateChanges(
            this.model.get('groupType') !== constants.REPORTS_SHARED_GROUP_TYPE,
            this.model.get('currentPermissionList'),
            this.applyChangesAction, this);
    }

    applyChangesAction() {

        const newValues = this.getNewValues();
        const oldVlaues = this.getOldValues();

        undoService.add({
            undo: () => {
                this.persistData(oldVlaues);
            },
            redo: () => {
                this.persistData(newValues);
            }
        }, textConstants.UNDO_UPDATE_REPORT)

        this.persistData(newValues);
    }

    persistData(details){
        // Saving Changes made on the report.
        console.log('persistData', details)
        restService.updateReport(details.reportId, details.name, details.isActive, details.permissionsToSend).then((data)=> {
            console.log('updated Report');
            console.log(data);
            eventBus.trigger(constants.EV_UPDATE_REPORT_DETAILS, details.reportId, details.groupType, details.groupId);
            eventBus.trigger('applyNameReportChanges', details.reportId, details.groupType, details.name);
        }).catch((err)=> {
            console.log('Error on update', err);
        })
    }
    
    getNewValues(){
        const reportId = this.model.get('reportId');
        const groupId = this.model.get('GroupId');
        const groupType = this.model.get('groupType');
        const name = this.model.get('currentReportName');
        const isActive = this.model.get('currentIsActive');

        const currentPermissionList = this.model.get('currentPermissionList');
        // console.log('Current Permissions', currentPermissionList);
        const permissionsToSend = this.formatPermissionsForResponse(currentPermissionList);
        
        return {
            reportId: reportId,
            groupId: groupId,
            groupType: groupType,
            name: name,
            isActive: isActive,
            permissionsToSend: permissionsToSend
        }
    }

    getOldValues(){
        const reportId = this.model.get('reportId');
        const groupId = this.model.get('GroupId');
        const groupType = this.model.get('groupType');
        const name = this.model.get('reportName');
        const isActive = this.model.get('isActive');

        const permissionList = this.model.get('permissionList');
        // console.log('Original Permissions', permissionList);
        const permissionsToSend = this.formatPermissionsForResponse(permissionList);

        return {
            reportId: reportId,
            groupId: groupId,
            groupType: groupType,
            name: name,
            isActive: isActive,
            permissionsToSend: permissionsToSend
        }
    }

    cancelChanges() {
        this.model.set('currentReportName', this.model.get('reportName'), {silent: true});
        this.model.set('currentIsActive', this.model.get('isActive'), {silent: true});

        this.model.set('currentPermissionList', _.cloneDeep(this.model.get('permissionList')),{silent:true});

        this.model.set('hasChanges', false, {silent: true});
        console.log("Report Model",this.model);
        this.render();
    }

    formatPermissionsForResponse(permissions) {
        return FormDetailsView.formatPermissionsForResponse(permissions);
    }

    addPermission(ev) {
        ev.preventDefault();
       
        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        setTimeout(() => {
            restService.browseAllUsers().then((usersData) => {
                // console.log("The users data", usersData);

                const users = (ud => {
                    let userAccum = [];
                    userAccum.push(PermissionsDetailView.createUserSpecialItem('Everyone'));

                    if (ud.AllUsers.User) {
                        userAccum = _.union(userAccum, util.enforceArrayType(usersData.AllUsers.User));
                    }
                    return userAccum;
                })(usersData);

                // console.log("new users", users);
                const items = users.map((item) => {
                    return {
                        id: item['@id'],
                        label: item['@caption'],
                        listType: item['@type'],
                        items: item
                    }
                });
                // console.log("items", items);

                const isReport = true;

                const permissionView = new SelectItemModalView({ model: new Model({ items: items, infiniteScrolling: constants.INFINITE_SCROLL_ENABLED }), spinner: spinner });
                permissionView.render().then(selectedItem => {

                    if (selectedItem) {
                        // console.log('Added Permission Reports', selectedItem);

                        // Checking if the permission selected is not already present in the current list.
                        // (Note the World and Everyone have identical IDs. Hence the looser comparion)
                        const currentPermissionList = this.model.get('currentPermissionList');
                        const permissionsChanged = currentPermissionList.filter((permission) => {
                            return permission['@id'] === selectedItem.items['@id']
                                && permission['@caption'] === selectedItem.items['@caption'];
                        });


                        if (permissionsChanged.length === 0) {

                            const newItem = _.cloneDeep(PermissionsDetailView.createPermissionForItem(selectedItem, isReport));
                            currentPermissionList.push(newItem);

                            this.model.set(
                                {
                                    'hasChanges': true,
                                    'currentPermissionList': currentPermissionList
                                }, { silent: false });

                            // This second, triggers deep change
                            this.model.trigger('change', this.model);
                            const
                                viewerId = selectedItem.items['@id'],
                                viewerName = selectedItem.items['@caption'];
                            PermissionsDetailView.selectPermissionViewer(viewerId, viewerName);

                        }
                    }
                }).catch((errMsg) => {
                    console.log(errMsg);
                    notificationService.error(errMsg);
                });
            });
        });
    }

    removePermission(ev){
        ev.preventDefault();
        const
            $row = $(`select[name='permissions']`),
            selectedUser = $row.val(),
            selectedUserId = $row.children(':selected').attr('id'),
            isWorldOrEveryone = 'World' === selectedUser || 'Everyone' === selectedUser;

        // console.log('Removed Permission Forms',selectedUser);
        const currentPermissionList = this.model.get('currentPermissionList');
        const currentPermissionListWithRemovedElement = currentPermissionList.filter( user => isWorldOrEveryone
            ? user['@caption'] !== selectedUser
            : user['@id'] !== selectedUserId  );

        if(currentPermissionListWithRemovedElement.length < currentPermissionList.length) {

            // console.log("Current Form Detail Model",this.model);
            this.model.set(
                {
                    'hasChanges': true, 'currentPermissionList': currentPermissionListWithRemovedElement,
                    'selectedViewer': '',
                    'selectedViewerId': ''
                }, {silent: true});
            this.model.trigger('change', this.model, {silent: false});
            this.render();

            window.setTimeout( () => PermissionsDetailView.clearPermPanel(constants.REPORTS_PERMISSION_ITEM_COUNT), 0);
        }
    }


    changeCheckboxes(event) {
        let name = event.target.name;
        let value = event.target.checked;
        this.model.set('hasChanges', true, {silent: true});
        this.model.set(name, value);
    }


    // Note: caught for ANY text field change, so filter 'em:
    changeTextInputField(event) {
        const name = event.currentTarget.name;
        const value = event.currentTarget.value;
        
        // PF-5944 Validate if value actually changed (for keyup event)
        let previousValue = this.model.get(name);

        if (previousValue !== value) {
            this.model.set(name, value, {silent: true});
            this.model.set('hasChanges', true, {silent: true});

            $('#reportActionSection').addClass('hide');
            $('#reportPermissionSection').removeClass('hide');
        }
    }

    // PF-4409
    // Called when any of three version radiobuttons selection changed
    changeVersion(event) {
        const name = event.target.name;
        const value = event.target.value;

        this.model.set(name, value, {silent: true});

        this.disablePublishingOptions();

        if(value==='deployed'){
            const deployNumVersion=$('#deployedVersion').val();
            this.model.set('deployedVersion', deployNumVersion, {silent: true});
            $('#publishReport').prop('disabled', true);
            $('#linkReport').prop('disabled', false);
            $('#viewReport').prop('disabled', false);

        } else if(value==='draft'){
            const latestVersion = $('#latestVersion').text();
            const draftNumVersion=$('#draftVersion').val();
            this.model.set('draftVersion', draftNumVersion, {silent: true});
            $('#publishReport').prop('disabled', draftNumVersion !== latestVersion);
            $('#linkReport').prop('disabled', true);
            $('#viewReport').prop('disabled', true);
        }
        // PF-4409 - Manage buttons for "latest"
        else if(value==='latest'){
            // Module value 'deployedVersion' is not useful here. It is the currently selected published item,
            // which may not be the latest deployed/published version. The #latestPublished DOM text item is stable.
            const latestPublished = $('#latestPublished').text();
            const draftNumVersion=$('#draftVersion').val();
            const hasDraft = !latestPublished || draftNumVersion;
            const latestVersion = $('#latestVersion').text();
            const versionSplit = latestVersion.split('.');
            const isFinalVersion = versionSplit.length === 2 && parseInt(versionSplit[1]) === 0;
            $('#publishReport').prop('disabled', isFinalVersion);
            $('#linkReport').prop('disabled',  !(latestPublished || hasDraft));
            $('#viewReport').prop('disabled',  !(latestPublished || hasDraft));
        }
    }

    // PF-4409
    // This method governs enabling of the Publish button as a function of the selected published
    // version. Note that the enableButtons method is only called once, to statically set
    // selections and button conditioning. This method is called at each selection of draft or
    // published RBs.
    selectVersion(ev) {
        ev.preventDefault();
        const name = ev.target.name;
        let disablePublish = true;
        if (name !== 'deployedVersion') {
            const latestVersion = this.model.get('latestVersion');
            const propVal = ev.currentTarget.value;
            disablePublish = propVal !== latestVersion;
            this.model.set(name, propVal, { silent: true });
        }

        $('#publishReport').prop('disabled', disablePublish);
    }

    getSelectedVersionId(publishedOnly) {
        let versionList = this.model.get('versionList');
        let reportVersionId = '';
        const opt = $('input[name=version]:checked');
        // Latest Published Version Only For Reports
        if (opt[0].value === 'latest') {

            if (publishedOnly) {
                const deployedVersion = this.model.get('deployedVersion');
                const versionPart = deployedVersion.split('.');

                if (versionList instanceof Array) {
                    for (let version of versionList) {
                        if ((version['@MajorVersion'] === versionPart[0]) && (version['@MinorVersion'] === versionPart[1])) {
                            reportVersionId = version['@FormVersionId']
                            break;
                        }
                    }
                } else {
                    reportVersionId = versionList['@FormVersionId'];
                }
            } else {
                if (versionList instanceof Array) {
                    reportVersionId = versionList[0]['@FormVersionId'];
                } else {
                    reportVersionId = versionList['@FormVersionId'];
                }
            }
        }
        else if (opt[0].value === 'deployed') {
            reportVersionId = $('select[name=deployedVersion] option:selected').attr('formVersionId');
        }
        else if(opt[0].value === 'draft'){
            reportVersionId = $('select[name=draftVersion] option:selected').attr('formversionid');
        }

        return {reportVersionId: reportVersionId};
    }

    findVersionIndex(versionList, versionInfo) {
        let index = 0;
        _.forEach(versionList, (item, k) => {
            if (item['@FormVersionId'] === versionInfo.reportVersionId) {
                index = k;
                return k;
            }
        });
        return index;
    }

    design(ev) {
        const reportId = this.model.get('reportId');
        const versionList = this.model.get('versionList');
      
        const fName = this.model.get('formName');
        const versionInfo = this.getSelectedVersionId();
        const listIndex = this.findVersionIndex( versionList, versionInfo );

        const majorVersion = versionList instanceof Array ? versionList[listIndex]['@MajorVersion'] : versionList['@MajorVersion'];
        const minorVersion = versionList instanceof Array ? versionList[listIndex]['@MinorVersion'] : versionList['@MinorVersion'];
        const lastUpdateDate = this.model.get("lastUpdateUTC");

        util.setPanelDefaults();
        
        restService.getConnections().then((connections)=> {
            window.sessionStorage.setItem('pfConnections', JSON.stringify(connections));
        }).then(()=>{
            formLoadService.loadReport(reportId, majorVersion, minorVersion, fName, versionInfo.reportVersionId, lastUpdateDate).then(msg => {
                listService.dashboardLayout.leftPanelView.remove();
                listService.dashboardLayout.mainPanelView.remove();

                util.openHelpCenter(constants.KIND_REPORT);
            }, (errMsg) => {
                if(errMsg.trim() === restMessages.getTextEditedByOtherUser()){
                    util.showAlert(textConstants.EDITOR_DESIGN, textConstants.EDITOR_DESIGN_OPENED_BY_OTHER_USER, 150);
                }else{
                    notificationService.error( errMsg );
                }
            });
        }, ( errMsg ) =>{
            notificationService.error( errMsg );
        });
    }

    deleteReport(ev) {
        let reportId = this.model.get('reportId');
        let reportName = this.model.get('reportName');
        const reportLink = this.model.get('LinkId');
        const versionList = this.model.get('versionList');
        const groupId = this.model.get('GroupId');
        const groupType = this.model.get('groupType');
        const parentId = this.model.get('parentId');

        var reportDeleteModal = new ReportDeleteModal({
            model: new Model({
                reportName: reportName, reportId: reportId, reportLink: reportLink,
                versionList: versionList, groupType: groupType, groupId:groupId,parentId:parentId
            })
        });
        reportDeleteModal.render().then((result)=> {
            console.log(result);
        }).catch(err => console.log(err));
    }

    viewReport(ev) {
        if (this.model.get('groupType') === 'viewReports') {
            let reportVersionId = this.model.get('versionList');
            if (Array.isArray(reportVersionId)) {
                reportVersionId = reportVersionId[0];
            }

            this.playForm(reportVersionId['@FormVersionId']);
        }
        else {
            let id = this.model.get('LinkId');
			if(this.model.get('version') !== 'latest'){
				const versionInfo = this.getSelectedVersionId();
				id = versionInfo.reportVersionId
			}        
			this.playForm(id);
        }        
    }

    createNewInstanceReport(reportVersionId, reportId) {
        restService.createNewInstanceReport(reportVersionId).then((data) => {
            let dataSection = data.ReportXML['#cdata-section'];
            // TODO:  show the form maybe with the dataSection field
            eventBus.trigger('newInstance', reportId);
        }).catch((error) => {
            var msg = error || 'Unknown Error';
            console.log('error ', error);
            return (error);
        });
    }

    linkReport(ev) {
        // PF-9553 Validate if is a trial account
        let isTrial = this.model.get('isTrial');
      

        let reportId = this.model.get('reportId');
        let reportName = this.model.get('reportName');
        const width = this.model.get('Width');
        const height = this.model.get('Height');
        const reportLink = this.model.get('LinkId');
        const hostUrl = this.hostUrl;

        var linkModal = new LinkModal({
            model: new Model({ hostUrl: hostUrl,
                name: reportName, id: Base64Encoder.encodeToString(reportId), link: reportLink,
                width: width, height: height
            })
        });
        linkModal.render().then((result)=> {
            console.log(result);
        });
    }

    newInstance(ev) {
        //  check if the modal is gonna be displayed
        let reportId = this.model.get('reportId');
        let reportName = this.model.get('reportName');
        if (this.model.get('versionList') instanceof Array ||
            (this.model.get('versionList')['@MajorVersion'] !== '0' && this.model.get('versionList')['@MajorVersion'] !== 0)) {
            //  TODO create and display the new instance in a modal
            console.log('create new instance')
        } else {
            //  TODO:  create the modal
            console.log('display the modal')
        }
    }

    confirmRecoverDesign(e) {
        const LastRecoveryUpdateDate = this.model.get('LastRecoveryUpdateDate');
        if (!util.isEmpty(LastRecoveryUpdateDate)) {
            const recoverDate = util.formatUTC(LastRecoveryUpdateDate);
            const formId = this.model.get("reportId");
            const version = this.model.get("latestVersion").split(".");
            const lastUpdate = this.model.get("lastUpdateUTC");
            const recoverDesignModal = new RecoverDesignModal({ model: new Model({ formId: formId, recoverDate: recoverDate, fromAction: "publish", lastUpdate: lastUpdate }) });

            recoverDesignModal.render().then(result => {
                if (result === "recover") {
                    restService.openReport(formId, version[0], version[1], true).then(data2 => {
                        restService.getReportDetails(formId).then((reportDetailsResult) => {
                            this.model.set('versionList', reportDetailsResult.RESULT.RESPONSE.PrivateReportDetails.VersionList.Version, {silent: true});                            
                            this.model.set('latestVersion', reportDetailsResult.RESULT.RESPONSE.PrivateReportDetails.Version, {silent: true});
                            $("#designReport").trigger("click");
                        });
                    });
                } else if (result === "publish") {
                    this.confirmPublishReport();
                }
            });
        }
        else{
            this.confirmPublishReport();
        }
    }

    confirmPublishReport(e) {
        if ( util.isTrue(this.model.get('responsive')) && util.isTrue(this.model.get('containsMobileErrors')) ) {
            const
                alertText = 'Design elements are currently placed outside of the mobile canvas. Reports cannot be published until layout issues are resolved.',
                alertTitle = 'Layout issues',
                alertView = new AlertDialogView({model: new Model({text: alertText, title: alertTitle})});

            alertView.render();

        } else {
            const LastRecoveryUpdateDate = this.model.get('LastRecoveryUpdateDate');
            if ( this.model.get('deployedVersion') && util.isEmpty(LastRecoveryUpdateDate)) {  // Not first time publishing
                const
                    confirmationTitle = 'Publish Report',
                    confirmationText =
                        '<div class="row">' +
                        '  <div class="col-sm-12">' +
                        '    <p> Are you sure you want to publish a new version of the report? </p>'+
                        '    <p> This will replace your previously published version as the one which is shown by default for a new instance.</p>' +
                        '  </div>' +
                        '</div>';

                new ConfirmationModal( {
                    model: new Model( {
                        confirmationTitle: confirmationTitle,
                        confirmationText: confirmationText,
                        height: 196,
                        width: 500
                    })
                }).render().then(result => {
                    if ('Yes' === result) {
                        this.publishReport();
                    }
                });
            } else { // First time publishing
                this.publishReport();
            }
        }
    }

    publishReport() {
        let reportId = this.model.get('reportId');
        restService.deployReport(reportId).then((data) => {
            if (data.fieldsWithChangedDataType){
                let changedData = data.fieldsWithChangedDataType.field;
                changedData = changedData instanceof Array? changedData : [changedData];
                let items = '<br/>';

                changedData.forEach( item => {
                  items += item['@name'] + '<br/>';
                });
                let message = '  <div class="col-md-12">' +
                        '    Publishing the new version of the app resulted in the following fields having changed their data-type: <br/>'+
                        items + '<br/>' +
                        '     This can have unexpected effects in reports which refer to this fields. It is recommended that you verify all reports which use these fields, and if necessary re-fresh the corresponding data-sources in the reports.'+
                        '</div>';

                let simpleModal = new SimpleConfirmModalView({
                    model:new Model({
                        subtitle: 'Publish App',
                        confirmationText: message,
                        height: 300,
                        width: 500,
                        showCancel: false
                    })
                });

                simpleModal.render();
            }
            var groupType = this.model.get('groupType');
            var groupId = this.model.get('groupId');

            eventBus.trigger('deployReport', reportId, groupType, groupId);
        }).catch((error) => {
            notificationService.error(error);
            return (error);
        });
    }


    shareReport(ev) {
        let params = {
            isPrivate: this.model.get('isShared'), //this.model.get('groupType') === constants.REPORTS_SHARED_GROUP_TYPE ? true : false,
            reportId: this.model.get('reportId'),
            groupId: constants.DEFAULT_GROUP_ID,
            name: constants.DEFAULT_GROUP_ID,
            groupType:this.model.get('groupType'),
            itemId: this.model.get('GroupId')
        };

        this.shareReportAPICall(params,ev).then(() => {

            undoService.add({
                undo:() => {
                    params.groupId = this.model.get('sharedGroupId');
                    params.groupType = constants.REPORTS_SHARED_GROUP_TYPE;
                    params.isPrivate = true;
                    this.shareReportAPICall(params,ev)
                },
                redo:() => {
                    params.groupId = constants.DEFAULT_GROUP_ID;
                    params.groupType = constants.REPORTS_PRIVATE_GROUP_TYPE;
                    params.isPrivate = false;
                    this.shareReportAPICall(params,ev)
                }
            },textConstants.UNDO_SHARE_REPORT);
        });

    }

    shareReportAPICall(params,ev){
        return restService.shareReport(params).then( data => {
            let sharedGroupId = data && data.GroupId ? data.GroupId : params.itemId.includes(params.reportId) ? constants.DEFAULT_GROUP_ID : params.itemId;
            this.model.set('sharedGroupId',sharedGroupId, {silent: true});
             if (!params.isPrivate) {
                eventBus.trigger('shareReport', params.reportId, constants.REPORTS_SHARED_GROUP_TYPE, params.itemId, sharedGroupId, data.Name);
            }else{
                eventBus.trigger('unShareReport', params.reportId, constants.REPORTS_PRIVATE_GROUP_TYPE, params.itemId, sharedGroupId, data.Name);
            }
        }).catch((error) => {
            var msg = error || 'Unknown Error';
            console.log('error ', error);
            return (error);

        });
    }


    // Called by render after template loaded.
    enableButtons() {
        // PF-4409 Reset from known state:
        (() => {
            $('#publishReport').prop('disabled', false);
            $('#linkReport').prop('disabled', false);
            $('#viewReport').prop('disabled', false);
        })();

        if (this.model.get('groupType') === constants.REPORTS_SHARED_GROUP_TYPE) {
            $('#shareReport').text('Unshare');
        }

        const selectedVersion = this.model.get('version');
        const userType = parseInt(userService.getUserType());

        // This method only invoked for intial view, which defaults to latest. Assert it anyway.
         if (selectedVersion === 'latest' && this.model.get('groupType') !== 'viewReports' && userType !== 1 && !this.model.get("simpleView")) {
            if ( !this.model.has('deployedVersion') ) {
                $('#publishReport').prop('disabled', false);
                $('#viewReport').prop('disabled',  true);
                $('#linkReport').prop('disabled',  true);
            } else {
                const draftVersion = isNaN(parseFloat(document.getElementById("draftVersion").value)) ? 0 :parseFloat(document.getElementById("draftVersion").value) ;
                const publishedVersion = isNaN(parseFloat(document.getElementById("deployedVersion").value)) ? 0 : parseFloat(document.getElementById("deployedVersion").value) ;
                if( publishedVersion > draftVersion || draftVersion === 0){
                    $('#publishReport').prop('disabled', true);
                }else{
                    $('#publishReport').prop('disabled', false);
                }
                $('#viewReport').prop('disabled',  false);
                $('#linkReport').prop('disabled',  false);
            }
        }

        // When owner is other than logged user, then disable buttons Unshare/Share, Migrate and Delete per Sorin's note on PF-2307
        if  (!FormDetailsView.isUserTheOwner(this.model) ){
            ['shareReport', 'migrateReport', 'deleteReport'].forEach( id =>  $(`#${id}`).prop('disabled', true) );
        }

         // PF-9553 Validate if is a trial account to disable link button
         let isTrial = restService.getProfile().IsTrial;
         this.model.set('isTrial', isTrial, {silent: true}); 
 
    }

    disablePublishingOptions() {
        let disabled = false;
        switch (this.model.get('version')) {
            case 'latest':
                const versionParts = this.model.get('latestVersion') ? this.model.get('latestVersion').split('.') : "0" ;
                if (versionParts[1] === '0') {
                    disabled = true;
                }

                $(`select[name='deployedVersion']`).prop('disabled', true);
                $(`select[name='draftVersion']`).prop('disabled', true);
                $('input[value="latest"]').prop('checked', true);

                // Note: publish button for "latest" handled by enable buttons
                // ReportDetailsView.disableLinkButton( disabled );
                $('#linkReport').prop('disabled', disabled);
                $('#viewReport').prop('disabled', disabled);
                break;
            case 'deployed':
                disabled = true;
                $(`select[name='deployedVersion']`).prop('disabled', false);
                $(`select[name='draftVersion']`).prop('disabled', true);
                $('input[value="published"]').prop('checked', true);

                $('#publishReport').prop('disabled', disabled);
                // ReportDetailsView.disableLinkButton( !disabled );
                $('#linkReport').prop('disabled', !disabled);
                $('#viewReport').prop('disabled', !disabled);
                break;
            case 'draft':
                $(`select[name='deployedVersion']`).prop('disabled', true);
                $(`select[name='draftVersion']`).prop('disabled', false);
                $('input[value="draft"]').prop('checked', true);

                $('#publishReport').prop('disabled', disabled);
                // ReportDetailsView.disableLinkButton( !disabled );
                $('#linkReport').prop('disabled', !disabled);
                $('#viewReport').prop('disabled', !disabled);
                break;
        }
    }

    playForm(id) {
        const instanceUrl = restService.getViewReportLinkUrl(id);
        const attributes = {url: instanceUrl, id: id };
        const newPlayForm = new PlayFormModal({model: new Model(attributes) });
        newPlayForm.render().then((result) => {});
    }

    migrateReport(e){
        e.preventDefault();
        let versionList = this.model.get('versionList') instanceof Array?
                            this.model.get('versionList') : [this.model.get('versionList')];
        let versions = [];
        for (let version of versionList) {
            let versionString =version['@MajorVersion']+'.'+version['@MinorVersion'];
            versions.push(versionString);
        }

        const isShared = this.model.get('groupType') === constants.REPORTS_SHARED_GROUP_TYPE;
        const isPrivate = util.isTrue(this.model.get('IsPrivate'));
        const migrateReportModal = new MigrateReportModal({model: new Model({
                // Enable transfer ownership option if details are for a shared form
                isPrivate: isPrivate,
                versions: versions })
        });
        migrateReportModal.render().then(importStyle => {
            if(importStyle && importStyle!=='Unauthorized'){
                let type = null;
                let reportId = null;
                let name = this.model.get('reportName');
                let ext = null;

                switch (importStyle.selection) {
                    case 'i':
                        this.importReportStyle();
                        break;
                    case 'n':
                        reportId = this.getVersionId(importStyle.options);
                        type = 'r';
                        name = name + ' (Report).pa';
                        this.exportReportVersion(reportId, type, name);
                        break;
                    case constants.DASHBOARD_XFER_OWNERSHIP:
                        this.chooseOwner();
                        break;
                }

            } else {
                notificationService.info( `Migration canceled.`);
            }
        });
    }

    //===========================================================================================================
    // Obtains a transfer-of-ownership destination user choice from the dashboard UI operator. If user chosen,
    // transfers form ownership to that user.
    //===========================================================================================================
    chooseOwner() {
        const reportId = this.model.get('reportId');
        FormDetailsView.displayUserSelectionModal().then(user => {
            restServiceAux.transferReportOwner(this.model.get('reportId'), user.id).then( result => {
                console.log(result);
                notificationService.success( `Ownership transferred to ${user.label}` );
                window.setTimeout(() => eventBus.trigger(constants.EV_UPDATE_REPORT_DETAILS, this.model.get('reportId')), 0);
            }, msg => {
                console.log(msg);
                notificationService.warning( msg );
            });

        }, reason => {
            console.log(reason);
            notificationService.info( `Ownership transfer canceled.`);
        });
    }

    exportReportVersion(reportId, type, name){        
        if (reportId !== null) {
            restService.exportFormResponseData(reportId, type, name);
        } else {
            notificationService.error( 'No version found' );
        }
    }
    getVersionId(version){
        let versionArray = version.split('.');
        let id = null;
        let versionList = this.model.get('versionList');

        if (versionList instanceof Array){
            let i = 0;
            do {
                let version = versionList[i];
                if (version['@MajorVersion'] === versionArray[0] && version['@MinorVersion'] === versionArray[1] ) {
                    id = version['@FormVersionId'];
                }
                ++i;
            } while (!id || i< versionList.length);
        } else {
            if (versionList['@MajorVersion'] === versionArray[0] && versionList['@MinorVersion'] === versionArray[1] ) {
                id = versionList['@FormVersionId'];
            }
        }
        return id;
    }

    importReportStyle(){
        const selectFileModal = new SelectFileModal();
        selectFileModal.render().then(selectedFile => {
            if (selectedFile && selectedFile !== 'Unauthorized'){
                this.importWithFile(selectedFile);
            }
        });
    }

    importWithFile(file){
        const reportId = this.model.get('reportId');
        let groupType = this.model.get('groupType');
        let groupId = this.model.get('groupId');
        restService.importReportStyle(reportId, file.name, file.file).then((result) => {
            const selectFileModal = new SelectFileModal({title: 'Import', itemName: result.Import.Item['@caption'], dependencies: 'None'});
            selectFileModal.render().then(selectedFile => {
                // reloading the report to show the new versions
                eventBus.trigger('deployReport', reportId, groupType, groupId);
            });
        }, ( errMsg ) =>{
           
            if (errMsg.CODE === '999') {
                const content = 'The selected file type is not supported. ' + 
                                'Forms and reports created in 4.x or earlier versions cannot be imported currently.';
                const selectFileModal = new SelectFileModal({title: 'Import', 
                        itemName: content, dependencies: 'None',
                        width: 450, 
                        message: "Import Failed."
                    });
                selectFileModal.render().then(selectedFile => {
                    // no actions required.
                });

                notificationService.error('File was not imported succesfully');
            } 
            else {
                notificationService.error( errMsg );
            }
        });
    }

    handleSelectedItem(ev){
        ev.preventDefault();
        //Starting spinner, each eventBus.trigger event invoked should be responsible to shut the spinner down
        let spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        const itemId = ev.currentTarget.attributes['data-itemid'].value;
        const gui = ev.currentTarget.attributes['data-guid'].value;
        const type = ev.currentTarget.attributes['data-type'].value;
        
        if(type === 'form'){
            eventBus.trigger('loadFormsView');
            setTimeout(() => {
               eventBus.trigger('newInstance', itemId);
            }, 500);
        }else if(type === 'report'){
            eventBus.trigger('relatedReport', itemId);
        }else if(type === 'connection'){
            eventBus.trigger('loadConnectionsView');
            setTimeout(() => {
                eventBus.trigger('relatedConnection', gui);
            }, 500);
        }else{
            spinner.stop();
        }
    }

    render() {

        const self = this;
        this.$el.empty();

        this.model.set('isOwner', restService.getProfile().UserId === this.model.get('ownerId'), {silent: true});
        
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.$el.css('cursor', 'default');

        // Cleaning select options first.
        $(`select[name='deployedVersion']`).empty();
        $(`select[name='draftVersion']`).empty();
        $(`select[name='permissions']`).empty();

        if (this.model.get('versionList') instanceof Array) {
            // Filling Version Dropdown with the data from the API after rendering.
            for (let version of this.model.get('versionList')) {
                if (version['@MinorVersion'] === '0') {
                    $(`select[name='deployedVersion']`).append($("<option></option>")
                        .attr('value', `${version['@MajorVersion']}.${version['@MinorVersion']}`)
                        .attr('formVersionId', version['@FormVersionId'])
                        .text(`${version['@MajorVersion']}.${version['@MinorVersion']}`));
                }
                else {
                    $(`select[name='draftVersion']`).append($("<option></option>")
                        .attr('value', `${version['@MajorVersion']}.${version['@MinorVersion']}`)
                        .attr('formVersionId', version['@FormVersionId'])
                        .text(`${version['@MajorVersion']}.${version['@MinorVersion']}`));
                }
            }
            if ($(`select[name='deployedVersion'] option`).length === 0) {
                $(`select[name='deployedVersion']`).prop('disabled', true);
                $(`input[value='deployed']`).prop('disabled', true);
            }
            if ($(`select[name='draftVersion'] option`).length === 0) {
                $(`select[name='draftVersion']`).prop('disabled', true);
                $(`input[value='draft']`).prop('disabled', true);
            }
        }
        else {
            $(`select[name='deployedVersion']`).prop('disabled', true);
            $(`input[value='deployed']`).prop('disabled', true);
            $(`select[name='draftVersion']`).prop('disabled', true);
            $(`input[value='draft']`).prop('disabled', true);
        }

        this.model.get('currentPermissionList').forEach( permission => {
            $(`select[name='permissions']`).append($("<option></option>")
                .attr('id', permission['@id'])
                .attr('value', permission['@caption'])
                .text(permission['@caption']));
        });
 
        if (this.model.get('isShared')){
            $('#sharedPermissions').removeClass('hide');
            $('#shareReport').html('Unshare');

            this.permsDetailView = new PermissionsDetailView({model: this.model, el: '#sharedPermissions', 'isReport': true});
            this.permsDetailView.render();
        }

        $('input[value="' + this.model.get('version') + '"]').attr('checked', true);

        this.disablePublishingOptions();
        this.enableButtons();

        if (this.model.get('hasChanges')) {
            $('#reportActionSection').addClass('hide');
            $('#reportPermissionSection').removeClass('hide');


            $('input[name="currentReportName"]').focus().val("").val(this.model.get('currentReportName'));
        }

        $('#applyChangesReport').on('click', (e) => {
           this.applyChanges();
        });


        const $perms = $(this.permsSelector);
        const permHandler = function () {

            const
                isReport = true,
                selectedUser = $(this).val() || '',
                selectedUserId = $(this).children(':selected').attr('id'),
                fullControlIdPrefix = constants.FORMS_FULL_CONTROL_PERM_DATA_INDEX;

            self.renderSelectedViewerLabel(selectedUserId, selectedUser);

            const permission = PermissionsDetailView.selectedViewerPerms(selectedUserId, selectedUser, self.model.get('currentPermissionList'));
            self.model.set('currentViewerPerms', permission, {silent: false});

            // Set dropdown selection to render selected visual

            // World and Everyone have same ID! We're lucky that they don't have dupe captions as normal entries could
            if ('World' === selectedUser || 'Everyone' === selectedUser) {
                $(`select[name='permissions'] option[value='${selectedUser}']`).attr('selected', 'selected');
            } else {
                $(`select[name='permissions'] option[id='${selectedUserId}']`).attr('selected', 'selected');
            }

            // Encapsulate setting special Full Control UI behavior if either Full Control option set
            (() => {
                const isEitherFullControlChecked
                    = $(`#${fullControlIdPrefix}allow`).prop('checked')
                    || $(`#${fullControlIdPrefix}deny`).prop('checked');
                PermissionsDetailView.disableNormalRows(isEitherFullControlChecked, isReport);
            })();

            PermissionsDetailView.conditionWorldPermUI(selectedUser, permission.length);


        };
        $perms.off('change');
        $perms.on('change', permHandler);

        this.delegateEvents();
        return this;
    }


    renderSelectedViewerLabel(selectedViewerId, selectedViewer ){
        this.model.set( {
            'selectedViewer': selectedViewer,
            'selectedViewerId': selectedViewerId
        }, {silent: true});

    }

    refresh(){
        if(this.model.get('hasChanges')){
            
            let simpleModal=new SimpleConfirmModalView({
                model:new Model({subtitle:`Report - ${this.model.get("reportName")}`,
                    confirmationText:`Are you sure you want to refresh this page?\r All changes made on the current page will be lost.`,
                    height:200,
                    width:400})
            });
            simpleModal.render().then((result)=>{
                if (result === 'Ok') {
                    // Find current report ID
                    let reportId = this.model.get('reportId');
                    eventBus.trigger(constants.EV_UPDATE_REPORT_DETAILS, reportId,constants.REPORTS_SHARED_GROUP_TYPE);
                }
            }).catch((err)=> {
                console.log('Error Showing Refresh Confirmation Message', err);
                NotificationService.error('Error Showing Refresh Confirmation Message' + err.MESSAGE);
            });
        }
        else{
            const refreshButton = $('#pf-refresh-main-view');
            const refreshItemId = refreshButton.attr('data-appid');
            if(refreshItemId !== -1){
                eventBus.trigger(constants.EV_UPDATE_REPORT_DETAILS, refreshItemId, this.model.get('groupType'));
            }else{
                let reportId = listService.dashboardLayout.leftPanelView.detailView.model.get('reportId');
                eventBus.trigger(constants.EV_UPDATE_REPORT_DETAILS, reportId,this.model.get('groupType'));
            }
        }       
    }

}

export default ReportDetailsView;

